import { useTeamSetupAreaContext } from './TeamSetupAreaContext';

export function useSetupAreaLabelsHelper() {

  const teamSetupAreaContext = useTeamSetupAreaContext();
  const teamSetupArea = teamSetupAreaContext?.teamSetupArea;

  const getFieldTypeLabel = () => {
    return teamSetupArea?.isCustom ? 'Format' : 'Box Type';
  };

  return {
    getFieldTypeLabel
  };
}
